import * as React from "react";
// UI Frameworks
import { Form } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Button from "components/Button";
import Input from "components/Input";
import InputMobile from "components/InputMobile";
// Utilities and hooks
import useUser from "hooks/useUser";
import { push } from "helpers/history";
import showNotify from "helpers/notify";
import { normalizeNumbers } from "helpers/persian";
// Styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	store: any;
	onSubmit: (data: any, mobileReg: boolean) => void;
}

interface CountryPhoneCodeValue {
	code?: number;
	phone?: string;
	short?: string;
}

const UserExistForm: React.FC<IProps> = props => {
	const { store, form, onSubmit } = props;
	const { getFieldDecorator } = form;
	const { isUserExist, registerByEmail } = useUser();
	const [loading, setLoading] = React.useState(false);
	const [mobile, setMobile] = React.useState<CountryPhoneCodeValue>({ code: 98, short: "IR" });

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					if (mobile.code === 98) {
						const isExist = await isUserExist(
							`0${values.mobile.startsWith("0") ? values.mobile.substr(1) : values.mobile}`,
						);
						if (isExist) {
							showNotify({
								text: "شما قبلا ثبت نام کرده اید لطفا وارد شوید",
								duration: 3000,
							});
							push("/auth/login");
						} else {
							// dispatch data (mobileReg)
							onSubmit(
								{
									...values,
									mobile: `0${
										values.mobile.startsWith("0") ? values.mobile.substr(1) : values.mobile
									}`,
								},
								true,
							);
						}
					} else {
						//@ts-ignore
						const res = await registerByEmail({
							mobile: `+${mobile.code}${values.mobile}`,
							email: values.email,
						} as Account.User);

						if (res) {
							onSubmit(values, false);
						}
					}
					setLoading(false);
				} catch (error) {
					setLoading(false);
				}
			}
		});
	}

	function handleChange(e: CountryPhoneCodeValue): void {
		setMobile(e);
	}

	return (
		<Form onSubmit={handleSubmit} className={styles["register-form"]}>
			<Form.Item label="شماره موبایل">
				{getFieldDecorator("mobile", {
					initialValue: store.mobile,
					normalize: normalizeNumbers,
					rules: [
						// {
						// 	...(mobile && mobile.code !== 98 && { pattern: new RegExp("^[0-9]{5,15}$") }),
						// 	...(mobile && mobile.code === 98 && { pattern: new RegExp("^(9)[1-9]{9}$") }),
						// 	message: "لطفا شماره موبایل خود را صحیح وارد نمایید",
						// },
						{
							required: true,
							transform: value => (value ? value.trim() : value),
							message: "لطفا شماره موبایل خود را وارد نمایید",
						},
					],
				})(<InputMobile type="tel" onChangeCountry={handleChange} />)}
			</Form.Item>
			{mobile && mobile.code !== 98 && (
				<Form.Item label="ایمیل" help="ایمیل تایید به این آدرس ارسال خواهد شد.">
					{getFieldDecorator("email", {
						normalize: normalizeNumbers,
						rules: [
							{
								type: "email",
								message: "لطفا ایمیل خود را صحیح وارد نمایید",
							},
							{
								required: true,
								transform: value => (value ? value.trim() : value),
								message: "لطفا ایمیل خود را وارد نمایید",
							},
						],
					})(<Input type="email" className="ltr" />)}
				</Form.Item>
			)}
			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={loading}>
					ثبت نام
				</Button>
			</Form.Item>
		</Form>
	);
};

export default Form.create<IProps>({ name: "userExist_form" })(UserExistForm);
